import React from 'react';

import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    textAlign: "center",
    width: "100%",
    fontSize: "0.75rem",
    margin: 0,
    padding: 10
  }
}

const EmptyRowsMessage = ({ classes, message }) => <p className={classes.root}>{message}</p>

export default withStyles(styles)(EmptyRowsMessage);